export class SignalSubscription {
  private unsubscribed = false;

  constructor(private unsubscribeFn: () => void) {}

  unsubscribe(): void {
    if (!this.unsubscribed) {
      this.unsubscribeFn();
      this.unsubscribed = true;
    }
  }

  get isActive(): boolean {
    return !this.unsubscribed;
  }
}

export class SubscriptionManager {
  private subscriptions: SignalSubscription[] = [];

  add(subscription: SignalSubscription): void {
    this.subscriptions.push(subscription);
  }

  unsubscribeAll(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  get count(): number {
    return this.subscriptions.filter((s) => s.isActive).length;
  }
}
